var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-points-soon"},[_c('div',{staticClass:"box"},[_c('header'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("即将到账的积分")]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v("即将到账积分为购买商品或参加活动赠送的积分，在一定时间后积分将会到账并归入您的可用积分。")]),_vm._v(" "),_c('footer',[_c('div',{on:{"click":_vm.onSubmit}},[_vm._v("我知道了")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }